var map = {
	"./anthropic-light.svg": 93389,
	"./auth0-light.svg": 42067,
	"./aws-light.svg": 6562,
	"./axonius-light.svg": 73472,
	"./carbonblack-light.svg": 82685,
	"./carbonblackAudit-light.svg": 65756,
	"./carbonblackDataStreaming-light.svg": 97841,
	"./docusign-light.svg": 88345,
	"./github-light.svg": 96752,
	"./githubAuditStreaming-light.svg": 14815,
	"./githubWebhooks-light.svg": 57322,
	"./greynoise-light.svg": 26672,
	"./http-ingest-light.svg": 34548,
	"./juniper-light.svg": 24044,
	"./netskope-light.svg": 71050,
	"./onelogin-light.svg": 25446,
	"./openai-light.svg": 57747,
	"./orca-light.svg": 40454,
	"./proofpoint-light.svg": 30645,
	"./sublime-light.svg": 78520,
	"./tailscale-light.svg": 25217,
	"./tenable-light.svg": 53592,
	"./tines-light.svg": 30584,
	"./vercel-light.svg": 38968,
	"./zeek-light.svg": 18142,
	"./zendesk-light.svg": 25729
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 38747;